export enum EPackagingType {
  CARTON = "C",
  SHOVE = "S",
  BAG = "B",
  CAN = "A",
}
